import React from 'react';
import styled from 'styled-components';
import { scroller } from 'react-scroll';

import OrangeButton from '../../core/components/OrangeButton';
import MoreAdsIcon from '../images/icon-circle-headset-blue.svg';

const PackageBox = styled.article`
  box-sizing: border-box;
  display: block;
  padding-bottom: 20px;
  margin: 24px 16px 0;
  background: #fff;
  border-radius: 8px;
  color: #323232;
  text-align: center;
  border: solid 1px #e5e5e5;
  position: relative;

  @media(min-width: 1000px){
    flex: 0.33;
    margin: 0 5px;
    padding-left: 5px;
    padding-right: 5px;
  }
`;

const PackageContainer = styled.div`
  position: relative;
  padding-top: 24px;

  @media(min-width: 1000px){
    padding-top: 0px;
    position: absolute;
    top: 50%;
    transform: translate(0%, -50%);
  }
`;

const Title = styled.div`
  font-size: 24px;
  color: #4a4a4a;
  line-height: 1.33;
  margin: 24px 48px 8px;
`;

const Description = styled.div`
  font-size: 14px;
  line-height: 1.43;
  color: #999999;
`;

const ContactHours = styled.div`
  font-size: 12px;
  line-height: 1.33;
  color: #4a4a4a;
`;

const ContactButton = styled(OrangeButton)`
  display: block;

  @media(min-width: 1000px){
    display: inline-block;
    width: 100%;
  }
`;


const ContactButtonWrapper = styled.div`
  padding: 24px 32px 8px;
`;

const handleClick = () => {
  scroller.scrollTo('insidesales', {
    duration: 1500,
    delay: 100,
    smooth: true,
    offset: -150,
  });
};

const ProductItemContact = () => (
  <PackageBox data-e2e="subscription-item">
    <PackageContainer>
      <img
        width="64"
        height="64"
        alt="Adquira mais planos"
        src={MoreAdsIcon}
      />
      <Title>
        Quer um plano ainda maior?
      </Title>
      <Description>
        Converse com nossa equipe de vendas!
      </Description>
      <ContactButtonWrapper>
        <ContactButton onClick={() => handleClick()}>
          Entrar em contato
        </ContactButton>
      </ContactButtonWrapper>
      <ContactHours>
        Segunda a sexta, de 09:00 a 18:00
      </ContactHours>
    </PackageContainer>
  </PackageBox>
);

export default ProductItemContact;
